import PropTypes from 'prop-types';

export const MINIMUM_CROP_DIMENSION = 4;
export const CROP_THUMB_NE = 'crop-handle-ne';
export const CROP_THUMB_SE = 'crop-handle-se';
export const CROP_THUMB_SW = 'crop-handle-sw';
export const CROP_THUMB_NW = 'crop-handle-nw';
export const CROP_THUMB_DIRECTIONS = [
    CROP_THUMB_NE,
    CROP_THUMB_SE,
    CROP_THUMB_SW,
    CROP_THUMB_NW,
];
export const DIRECTION_TO_CLASSNAME_MAP = {
    [CROP_THUMB_NE]: 'eds-image-cropper__thumb--ne',
    [CROP_THUMB_SE]: 'eds-image-cropper__thumb--se',
    [CROP_THUMB_SW]: 'eds-image-cropper__thumb--sw',
    [CROP_THUMB_NW]: 'eds-image-cropper__thumb--nw',
};

export const CROP_MASK_PROP_TYPE = PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
});
